module.exports = __webpack_public_path__ + "img/wang.ac32f356.png";